import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static targets = [
    'sortCtr', 'trend', 'editBtn', 'saveBtn', 'timeFrames',
    'interval', 'timeSelects', 'editActions', 'container'
  ];

  connect() {
    this.initSortable();
  }


  initSortable() {
    document.addEventListener("turbo:load", this.initializeIntervalSelect.bind(this));
    this.sortable = new Sortable(this.sortCtrTarget, {
      animation: 150,
      sort: true,
      handle: ".drag-handle",
      onEnd: this.dragEnd.bind(this),
      removeCloneOnHide: true,
      onStart: this.dragStart.bind(this),
      onMove: function (evt) {
        return evt.related.className.indexOf('hidden') === -1;
      }
    });
  }

  // Turbo drive causes the select2 to 'forget' previous selections
  initializeIntervalSelect(event) {
    const prevSelected = this.intervalTarget.querySelector('option[selected]');
    if (prevSelected) {
      this.intervalTarget.value = prevSelected.value;
      $(this.intervalTarget).select2({ minimumResultsForSearch: Infinity }).trigger('change');
    }
  }

  dragStart(evt) {
    this.containerTarget.querySelectorAll('.card').forEach(card => {
      card.classList.add('dragging-item');
    });
    this.containerTarget.querySelectorAll('.trend-info').forEach(card => {
      card.setAttribute('hidden', '');
    });
    this.containerTarget.querySelectorAll('canvas').forEach(card => {
      card.setAttribute('hidden', '');
    });
  }

  edit(event) {
    event.preventDefault();
    this.sortCtrTarget.classList.add('drag-handle');
    this.sortable.option("disabled", false); // Enable sorting
  }

  save(event) {
    this.sortCtrTarget.classList.remove('drag-handle');

    const updateArray = this.trendTargets.map((el, index) => ({
      id: el.dataset.trendId,
      index: index,
      hidden: el.classList.contains('hidden')
    }));

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    fetch('/financial_metrics/trends/bulk_update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ trend: updateArray }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
      });
  }

  dragEnd(event) {
    this.containerTarget.querySelectorAll('.card').forEach(card => {
      card.classList.remove('dragging-item');
    });
    this.containerTarget.querySelectorAll('canvas').forEach(card => {
      card.removeAttribute('hidden');
    });
    this.containerTarget.querySelectorAll('.trend-info').forEach(card => {
      card.removeAttribute('hidden');
    });

    setTimeout(() => {
      event.item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 25); 

    this.save(event);
    const customEvent = new CustomEvent('reinitializeChart', { bubbles: true });
    event.item.dispatchEvent(customEvent);
  }


  toggleCurrentMonth(event) {
    event.preventDefault();
    const showCurrentMonth = this.data.get('show-current-month') !== 'true';
    this.data.set('show-current-month', showCurrentMonth);
    this.requestChartUpdate();
  }

  requestChartUpdate(event) {
    let data = {};
    let preferenceKey, preferenceValue;

    if (event && event.target === this.intervalTarget) {
      preferenceKey = 'interval';
      preferenceValue = this.intervalTarget.value;
      data = { i: preferenceValue };
    } else if (event && event.target === this.timeFramesTarget) {
      preferenceKey = 'time_frame';
      preferenceValue = this.timeFramesTarget.value;
      data = { tf: preferenceValue };
    }

    data.cm = this.data.get('show-current-month');
    const loadTrendsPath = event.target.dataset.trendsPath || '/trends/';

    const afterSave = () => {
      $.ajax({
        data: data,
        url: loadTrendsPath,
        success: (response) => {
          this.timeSelectsTarget.innerHTML = response;
        },
      });

      for (const trend of this.trendTargets) {
        if ($(trend).hasClass('hidden')) continue;
        trend['trend'].requestChartData(data, true);
      }
    };

    if (preferenceKey && preferenceValue) {
      this.savePreference('financial_metrics', preferenceKey, preferenceValue)
        .then(afterSave)
        .catch(error => {
          console.error('Preference save failed, not refreshing UI:', error);
        });
    } else {
      afterSave();
    }
  }

  savePreference(preferenceType, preferenceKey, value) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    return fetch('/user_preferences', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        user_preference: {
          preference_type: preferenceType,
          preference_key: preferenceKey,
          preference_value: { value: value }
        }
      })
    })
      .then(response => response.json())
      .then(data => {
        if (!data.success) {
          console.error('Failed to save preference:', data.errors);
          return Promise.reject(new Error('Preference update failed'));
        }
        return data;
      })
      .catch(error => {
        console.error('Error saving preference:', error);
        return Promise.reject(error);
      });
  }
}
